import { defineStore } from 'pinia'
import LangType from '@/utils/i18n/LangType'

const lang = navigator.language.slice(0, 2)
export const useSettingStore = defineStore('sysSetting', {
  state: () => ({
    collapsed: false,
    visitorId: '',
    openKeys: [] as (string | number)[],
    selectedKeys: [] as (string | number)[],
    locale: (LangType[lang] ? lang : 'en') as keyof typeof LangType,
    /**翻译数据json */
    langJson: {} as Record<string, any>,
    station: {
      print: '',
      printer: '',
      template: 1,
      templateKey: '',
      language: 'CN',
      isShowLogo: true
    } as Record<string, any>,
    lodopStatus: false as boolean,
    pendingCountData: [] as string[],
    printerList: [] as Record<string, any>[],
    signPath: ''
  }),
  getters: {
    getCollapsed: (state) => state.collapsed,
    getOpenKeys: (state) => state.openKeys,
    getSelectedKeys: (state) => state.selectedKeys,
    getStation: (state) => state.station,
    getVisitorId: (state) => state.visitorId
  },
  actions: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setOpenkeys(keys: number[]) {
      if (this.openKeys.length) return
      this.openKeys = keys
    },
    setSelectedKeys(keys: number[]) {
      this.selectedKeys = keys
    },
    setSignPath(path: string) {
      this.signPath = path
    },
    setVisitorId(str: string) {
      this.visitorId = str
    }
  },
  persist: {
    storage: localStorage,
    paths: ['collapsed', 'locale', 'langJson', 'station', 'printerList', 'signPath', 'visitorId']
  }
})
